<template>
	<div :class="classes">
		<ThumbnailPolaroid
			v-for="result in results"
			:key="result.id"
			:submission="result"
			:numbered="numbered"
			:wall="wall"
			@click="select"
		/>
	</div>
</template>

<script>
import ThumbnailPolaroid from '@/components/main/ThumbnailPolaroid'

const LAYOUTS = ['odd', 'even', 'wall-leaderboard', 'wall-gallery']

export default {
	name: 'Gallery',
	props: {
		results: Array,
		layout: {
			type: String,
			validator: v => LAYOUTS.includes(v),
			default: 'even'
		},
		numbered: {
			type: Boolean,
			default: false
		},
		wall: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		classes() {
			return `gallery gallery--${this.layout}`
		},
		empty() {
			return this.results.length === 0
		}
	},
	methods: {
		select(id) {
			this.$emit('view', id)
		},
		emitUpdated() {
			this.$emit('updated')
		}
	},
	watch: {
		results() {
			this.$nextTick(this.emitUpdated)
		}
	},
	mounted() {
		this.emitUpdated()
	},
	components: {
		ThumbnailPolaroid
	}
}
</script>

<style lang="scss" scoped>
@use 'sass:math';
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';
@import '~scss/mq';

.gallery {
	display: grid;
	gap: 2rem;
	grid-template-rows: auto;
	grid-template-columns: minmax(0, 1fr);
	padding: 0 2rem;

	> * {
		justify-self: center;
	}

	&--wall-leaderboard {
		grid-template-rows: auto;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 3rem;
		max-width: 700px;
		margin: 0 auto;
	}
	&--wall-gallery {
		width: 100%;
		grid-template-rows: auto;
		grid-template-columns: repeat(1, minmax(0, 1fr));
		gap: 2.5rem;
		padding: 1rem 1.5rem;
	}

	@include mq(sm) {
		&--wall-gallery {
			grid-template-rows: auto;
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}
	}

	@include mq(md) {
		&--even {
			grid-template-rows: auto;
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}
		&--odd {
			gap: 3rem;
			grid-template-rows: auto;
			grid-template-columns: repeat(3, minmax(0, 1fr));
		}
		&--wall-gallery {
			grid-template-rows: auto;
			grid-template-columns: repeat(3, minmax(0, 1fr));
		}
	}

	@include mq(lg) {
		&--even {
			grid-template-rows: auto;
			grid-template-columns: repeat(4, minmax(0, 1fr));
		}
		&--odd {
			gap: 4.5rem;
		}
		&--wall-leaderboard {
			grid-template-rows: auto;
			grid-template-columns: repeat(4, minmax(0, 1fr));
			max-width: 900px;
		}
		&--wall-gallery {
			grid-template-rows: auto;
			grid-template-columns: repeat(4, minmax(0, 1fr));
		}
	}

	@include mq(xl) {
		&--wall-gallery {
			grid-template-rows: auto;
			grid-template-columns: repeat(5, minmax(0, 1fr));
		}
	}
}
</style>
